import useMerchant from "@/hooks/useMerchant";

export const useReferralLink = () => {
  const { referralCode } = useMerchant();

  const baseURL = typeof window !== "undefined" ? window?.location?.origin : "";
  const referralLink = `${baseURL}/invite/${referralCode}`;

  return { referralLink };
};
